import React, { useEffect, useState } from "react";
import Footer from "../../Common/Footer/Footer";
import Navbar from "../../Nav/Navbar";
import Banner from "./Banner";
import Process from "./Process";
import { interiorDesign } from "../../Data/Data";
import Sidedrawer from "../../Nav/Sidedrawer";
import Loader from "../../Common/Loader";
function InteriorDesign({ onToggle, handler, show, backdrop }) {
  const [display, setDisplay] = useState(false);
  useEffect(() => {
    document.title = "Interior Design | Dastkaar";
  }, []);
  useEffect(() => {
    setInterval(() => {
      setDisplay(true);
    }, 1500);
  }, []);
  return (
    <div data-lenis-prevent>
      {display === false ? (
        <Loader />
      ) : (
        <>
          <Navbar onToggle={onToggle} handler={handler} />
          <Sidedrawer onToggle={onToggle} show={show} handler={handler} />
          {backdrop}
          <main>
            <Banner />
            <Process props={interiorDesign} />
          </main>
          <Footer />
        </>
      )}
    </div>
  );
}

export default InteriorDesign;
